import { render, staticRenderFns } from "./i-invoice-list.vue?vue&type=template&id=1236a4b8"
import script from "./i-invoice-list.vue?vue&type=script&lang=js"
export * from "./i-invoice-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports